<template>
  <router-link
    v-if="hasRoute"
    :to="to">
    <slot></slot>
  </router-link>
</template>

<script>

export default {
  props: {
    to: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasRoute () {
      const routes = this.$router.options.routes;
      return routes.find(route => route.path === this.to) !== undefined;
    }
  }
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/SafeRouterLink.vue